import React from "react";
import {
  StyleSheet,
  View,
  Text,
  FlatList,
  Image,
  SectionList,
  TouchableOpacity,
} from "react-native";
import { blackColor } from "../../common/colors";
import manipulacja from "../../containers/SliderBox/manipulacjaAWywieranieWplywu.png";
import komunikacja from "../../containers/SliderBox/oSkutecznejKomunikacji.png";
import sposoby from "../../containers/SliderBox/sposobyKomunikacji.png";
import yellowBox from "../../containers/SliderBox/yellow.png";
import blueBox from "../../containers/SliderBox/blue.png";
import redBox from "../../containers/SliderBox/red.png";
import greenBox from "../../containers/SliderBox/green.png";
import routes from "../../routing/routes";
import t from "../../translations";

const SliderBox = ({ navigation }) => {
  const onClick = (route) => () => navigation.navigate(route);

  const ColorsItem = ({ image, route }) => (
    <TouchableOpacity onPress={onClick(route)}>
      <View
        style={{
          width: 138,
          height: 128,
          alignItems: "flex-start",
          justifyContent: "flex-end",
          padding: 20,
          margin: 2,
        }}
      >
        <Image source={image} style={styles.image} />
      </View>
    </TouchableOpacity>
  );

  const ListItem = ({ text, image, route }) => (
    <TouchableOpacity onPress={onClick(route)}>
      <View style={styles.sliderBox}>
        <Image source={image} style={styles.image} />
        <Text style={styles.text}>{text}</Text>
      </View>
    </TouchableOpacity>
  );

  const dataSliderBox = [
    {
      id: "1",
      group: 1,
      text: t("sliderBox_dataSliderBox_1_title"),
      image: komunikacja,
      route: routes.KnowladgeEffectiveCommunication,
    },
    {
      id: "2",
      group: 1,
      text: t("sliderBox_dataSliderBox_2_title"),
      image: manipulacja,
      route: routes.KnowladgeManipulation,
    },
    {
      id: "3",
      group: 1,
      text: t("sliderBox_dataSliderBox_3_title"),
      image: sposoby,
      route: routes.KnowladgeWaysOfCommunication,
    },
  ];

  const colorsDataBox = [
    {
      id: "1",
      group: 2,
      color: t("sliderBox_colorsDataBox_1"),
      image: yellowBox,
      route: routes.YellowAboutColorsPage,
    },
    {
      id: "2",
      group: 2,
      color: t("sliderBox_colorsDataBox_2"),
      image: blueBox,
      route: routes.BlueAboutColorsPage,
    },
    {
      id: "3",
      group: 2,
      color: t("sliderBox_colorsDataBox_3"),
      image: redBox,
      route: routes.RedAboutColorsPage,
    },
    {
      id: "4",
      group: 2,
      color: t("sliderBox_colorsDataBox_4"),
      image: greenBox,
      route: routes.GreenAboutColorsPage,
    },
  ];

  const DATA = [
    {
      id: "1",
      title: t("sliderBox_data_title_1"),
      data: dataSliderBox,
    },
    {
      id: "2",
      title: t("sliderBox_data_title_2"),
      data: colorsDataBox,
    },
  ];

  const Item = ({ data }) => {
    return (
      <>
        <FlatList
          horizontal={true}
          data={data}
          keyExtractor={(item) => item.id}
          renderItem={({ item }) => {
            return item.group === 1 ? (
              <ListItem key={item.id} {...item} />
            ) : (
              <ColorsItem key={item.id} {...item} />
            );
          }}
        />
      </>
    );
  };

  return (
    <View>
      <SectionList
        sections={DATA}
        keyExtractor={(item, index) => item + index}
        renderItem={({ section: { data } }) => null}
        renderSectionHeader={({ section: { title, data } }) => (
          <>
            <Text style={styles.titleAboutCommunication}>{title}</Text>
            <Item data={data} />
          </>
        )}
      />
    </View>
  );
};

export default SliderBox;

const styles = StyleSheet.create({
  sliderBox: {
    width: 170,
    height: 170,
    alignItems: "flex-start",
    justifyContent: "flex-end",
    padding: 20,
  },
  text: {
    fontSize: 14,
  },
  image: {
    width: 130,
    height: 104,
  },
  titleAboutCommunication: {
    textTransform: "uppercase",
    fontSize: 16,
    lineHeight: 16,
    letterSpacing: 0.25,
    color: blackColor,
    fontWeight: "500",
    paddingTop: 30,
    margin: 20,
  },
});
